export enum StatusDetalhesATPVEnum {
    PROCESSANDO = 1,
    FINALIZADO = 2,
    DADOS_INCONSISTENTES = 3,
    IMPEDIDO = 4,
    FALHA = 5,
}